import {
    AccordionSummary,
    AccordionDetails,
    IconButton,
    Stack,
    Alert
} from '@mui/material';
import { styled } from '@mui/material/styles';
import MuiAccordion from '@mui/material/Accordion';
import ListView from './list';
import React, { useEffect, useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SingleValue from './single-value-update';
import { Link } from 'react-router-dom';
import Mapping from '../mapping/mapping';
import ListViewInput from '../input/list-input';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { Typography, Collapse } from '@mui/material';
import { Add,  Edit, Remove } from '@mui/icons-material';
import EditOffIcon from '@mui/icons-material/EditOff';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import NestedSearch from './search';
import CONSTANT from '../../../Constant/Constant';
import moment from 'moment';
import GCCCp from '../../../config/ConcentConfig.json'
import ConsentAccordian from './consentAccordian';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {Tooltip} from '@mui/material';
import SourceList from '../../../config/ProfileDetailsData.json'

const sortData = (sortedValue, label) => {
    if (sortedValue !== undefined) {
        let allValueSorted = JSON.parse(JSON.stringify(sortedValue));
        let firstTopValues = JSON.parse(JSON.stringify(sortedValue));
        if (!['Relation', 'Address'].includes(label)) {

            firstTopValues = [].concat(sortedValue).sort((a, b) => {
                if (a.Rank !== undefined && b.Rank !== undefined && a.Rank.length > 0 && b.Rank.length > 0) {
                    return (a.Rank[0].value > b.Rank[0].value ? 1 : -1);
                } else if (a.Rank !== undefined && b.Rank === undefined) {
                    return -1;
                } else if (a.Rank === undefined && b.Rank !== undefined) {
                    return 1;
                } else {
                    return 1;
                }
            })
            allValueSorted = JSON.parse(JSON.stringify(firstTopValues));
            if (allValueSorted.length > CONSTANT.SHOW_VALUE_NUMBER) {
                firstTopValues = firstTopValues.slice(0, CONSTANT.SHOW_VALUE_NUMBER);
            }
        }
        return ({ allValueSorted, firstTopValues })
    } else {
        return ({ allValueSorted: undefined, firstTopValues: undefined })
    }
    }
   
    const Accordion = styled((props) => (
        <MuiAccordion disableGutters elevation={0} square {...props} />
    ))(({ theme }) => ({
        border: `none`,
        boxShadow:'rgba(0, 0, 0, 0.2) 0px 2px 1px -1px, rgba(0, 0, 0, 0.14) 0px 1px 1px 0px, rgba(0, 0, 0, 0.12) 0px 1px 3px 0px',
        '&:not(:last-child)': {
        
        },
        '&::before': {
        display: 'none',
        },
    }));

const MultiValue = (props) => {
    const [allValue, setAllValue] = useState()
    const [sourceConfig] = useState(SourceList)
    const [openPhone, setOpenPhone] = useState(false);
    const [openRole, setOpenRole] = useState(false);
    const [openAffilation, setOpenAffilation] = useState(false);
    const [openEmail, setOpenEmail] = useState(false)
    const [accordian, setAccordian] = useState(props.label !== 'Relation' ? true : false);
    const [label, setLabel] = useState(props.label);
    const [value, setValue] = useState();
    const [error, setError] = useState(false);
    const [newValue] = useState(Mapping[label]);
    const [addnewIdArray, setAddNewIdArray] = useState([]);
    const [indexView, setIndexView] = useState(CONSTANT.SHOW_VALUE_NUMBER);
    const [relationName, setRelationName] = useState('');
    const [urlRelation, setUrlRelation] = useState('');
    const [typeUrl, setTypeUrl] = useState('');
    const [editedValue, setEditedValue] = useState([]);
    const [editValueFlag, setEditValueFlag] = useState([]);
    const [changedFlag, setChangedFlag] = useState(false);
    const [editFlag, setEditFlag] = useState(true);
    const [updatedSpecialty] = useState(props.updatedSpecialty)
    const [addressEditIndex, setAddressEditIndex] = useState({})
    const [addressEditFlag, setAddressEditFlag] = useState()    
    const [editMode, setEditMode] = useState(false)
    const [addressEditIndexForVendor, setAddressEditIndexForVendor] = useState()    
    useEffect(() => {
        if (props.change) {
            setAddNewIdArray([])
            setEditedValue([]);
            setEditValueFlag([]);
        }
        setChangedFlag(props.change)
        setError(props.error)
        let sortTheValues = sortData(props.value, props.label);
        setLabel(props.label);
        setAllValue(sortTheValues.allValueSorted)
        setValue(sortTheValues.firstTopValues);

        if (props.label === 'Relation') {
            let LabelRelation;
            if (props.value.startObject.objectURI.split('/')[1] !== props.id) {
                LabelRelation = props.value.startObject.label;
                setUrlRelation(props.value.startObject.objectURI);
                setTypeUrl(props.value.startObject.type !== undefined ? props.value.startObject.type.split('/')[2] : '');
            } else {
                LabelRelation = props.value.endObject.label;
                setUrlRelation(props.value.endObject.objectURI);
                setTypeUrl(props.value.endObject.type !== undefined ? props.value.endObject.type.split('/')[2] : '');
            }
            setRelationName(((LabelRelation === undefined) || (LabelRelation !== undefined && LabelRelation.length === 0)) ? '<No Label>' : LabelRelation);
        }
    }, [props.label, props.id, props.error, props.change, props.value])

    /**
     * check all valid Addres attribute
     * @param {*} arrayValue 
     * @returns final flag 
     */
    const checkAllAddressAttribute = (arrayValue) => {
        let flag = false;
        if (arrayValue.length === 0) {
            return flag;
        } else {
            arrayValue.forEach((value) => {
                flag = flag || value.flag
            })
            return flag;
        }
    }

    const disableEditIcon = (editFlag, i) =>{
        setAddressEditIndex({...addressEditIndex, [i]: editFlag})
        setAddressEditIndexForVendor(i)
        setAddressEditFlag(editFlag)
    }

    /**
     * handel previous DCR change
     * @param {*} index 
     */
    const deletePreviousChange = (index) => {
        let dummyEditValue = JSON.parse(JSON.stringify(editedValue))
        let editKey = dummyEditValue.map(i => i.editKey).indexOf('id' + index);
        if (editKey !== -1) {
            editedValue.splice(editKey, 1)
        } else {
            editedValue.splice(editKey, 1)
        }
        let dummyEditValueFlag = JSON.parse(JSON.stringify(editValueFlag))
        let editKeyFlag = dummyEditValueFlag.map(i => i.editKey).indexOf('id' + index);
        if (editKeyFlag !== -1) {
            editValueFlag.splice(editKey, 1)
        } else {
            editValueFlag.splice(editKey, 1)
        }
       
        props.editValue(editedValue, checkAllAddressAttribute(editValueFlag), undefined, undefined, index)
    }

    const deleteSepcialty = (index) => {
        let valued = updatedSpecialty == undefined ? sortData(props.value, props.label) : sortData(updatedSpecialty, props.label)        
        valued['allValueSorted'] = [
          { ...valued['allValueSorted'][index], isDeleted: true }
        ];
        props.editValue(valued['allValueSorted'], false, 'Specialities', index)
    }

    const undoDeleteSepcialty = (index) => {
        let valued = updatedSpecialty == undefined ?  sortData(props.value, props.label) : sortData(updatedSpecialty, props.label)
        valued['allValueSorted'] = [
            { ...valued['allValueSorted'][index], isDeleted: false }
          ];
        props.editValue(valued['allValueSorted'], false, 'Specialities', index)
    }

    /**
     * Edit flag for address
     * @param {*} address 
     * @returns final flag
     */
    const checkAddressValue = (address) => {
        if ((address.AddressLine1 && address.StateProvience && !address.City
            && address.Zip && address.Zip[0].Zip5) &&
            (!address.AddressLine1[0].value || !address.StateProvience[0].value || !address.City[0].value
                || !address.Zip[0].Zip5[0].value)) {
            return true;
        } else {
            return false;
        }
    }

    /**
     * Edit the change on nested array
     * @param {*} index 
     */
    const EditChange = (index) => {
        editedValue.push({ ...allValue[index], editKey: ('id' + index) })
        editValueFlag.push({ flag: checkAddressValue(allValue[index]), editKey: ('id' + index) });
        props.editValue(editedValue, checkAllAddressAttribute(editValueFlag))
    }

    const handleClickMenu = (event) =>{
        EditRealtion(props.index)
        event.stopPropagation();
    };

    /**
     * Update the DCR for Nested Value
     * @param {*} newValue 
     * @param {*} index 
     * @param {*} flag 
     */
    const updateValue = (newValue, index, flag, Name) => { 
        if (editedValue.length === 0) {
            editedValue.push({ ...newValue, editKey: ('id' + index) })
            editValueFlag.push({ flag, editKey: ('id' + index) });
        } else {
            let dummyEditValue = JSON.parse(JSON.stringify(editedValue))
            let editKey = dummyEditValue.map(i => i.editKey).indexOf('id' + index);
            let dummyEditValueFlag = JSON.parse(JSON.stringify(editValueFlag))
            let editFlagKey = dummyEditValueFlag.map(i => i.editKey).indexOf('id' + index);
            //inseting item updated
            if (editKey !== -1) {
                editedValue.splice(editKey, 1, { ...newValue, editKey: 'id' + index })
            } else {
                editedValue.push({ ...newValue, editKey: 'id' + index });
            }
            //respective flag error checking
            if (editFlagKey !== -1) {
                editValueFlag.splice(editKey, 1, { flag, editKey: 'id' + index })
            } else {
                editValueFlag.push({ flag, editKey: 'id' + index });
            }
        }
        props.editValue(editedValue, checkAllAddressAttribute(editValueFlag), Name, index)
    }

    const updateRelation = (val, flag) => {       
        let updatedValue = JSON.parse(JSON.stringify(props.value)) 
        let affiliation = updatedValue['AffiliationClassification'] ? updatedValue['AffiliationClassification'] : []
        let affiliationUpdated = updatedValue['AffiliationClassification'] ? updatedValue['AffiliationClassification'] : []
        let activeFlag = updatedValue['ActiveFlag'] ? updatedValue['ActiveFlag'] : []       
        
        if(val.value != activeFlag[0].value && val.value == 'Y'){
            affiliationUpdated.map((aff, index) => { 
                // Update ActiveFlag if it exists
                if(aff['ActiveFlag'] && aff['ActiveFlag'][0]['value']){
                    let newActiveFlag = aff['ActiveFlag'][0]['value'] == 'N' ? 'N '+ String.fromCharCode(10142)+' Y' : 'N '+ String.fromCharCode(10142)+' Y';
                    // If you also want to update the original affiliation array
                    affiliationUpdated[index] = {
                        ...aff, 
                        ActiveFlag: [{ value: newActiveFlag}]
                    };
                }
        
                // Update EffectiveEndDate if it exists
                if(aff['EffectiveEndDate'] && aff['EffectiveEndDate'][0]['value']){
                    let todayDate = moment.utc(new Date()).format("YYYY-MM-DD");
                    let effectiveEndDate = moment.utc(new Date(aff["EffectiveEndDate"][0]["value"])).format("YYYY-MM-DD");
                    let newEffectiveEndDate = effectiveEndDate < todayDate ? effectiveEndDate+ ' ' + String.fromCharCode(10142)+ " 9999-12-31" : effectiveEndDate;
                    
                    affiliationUpdated[index] = {
                        ...affiliation[index],
                        EffectiveEndDate: [{ value: newEffectiveEndDate }]
                    }
                }
            });
            updatedValue = {...updatedValue, EffectiveEndDate:[{value:'9999-12-31'}], ActiveFlag: [{value : 'Y'}], IsStatusChanged: true}
            setValue({...value, ActiveFlag: [{value : 'Y'}], AffiliationClassification: affiliationUpdated })
            props.editValue(updatedValue, false)
        }
        else if(val.value != activeFlag[0].value && val.value == 'N'){
            affiliationUpdated.map((aff, index) => { 
                if(aff['ActiveFlag'] && aff['ActiveFlag'][0]['value']){
                affiliationUpdated[index] = {...aff, ActiveFlag: [{value : (aff['ActiveFlag'] && aff['ActiveFlag'][0]['value'] == 'Y' ? 'Y '+String.fromCharCode(10142)+ ' N' : 'N')}]}
                }
                if(aff['EffectiveEndDate'] && aff['EffectiveEndDate'][0]['value']){
                    let todayDate =  moment.utc(new Date()).format("YYYY-MM-DD")    
                    let effectiveEndDate = moment.utc(new Date(aff["EffectiveEndDate"][0]["value"])).format("YYYY-MM-DD")
                    affiliationUpdated[index] = {...affiliation[index], EffectiveEndDate: [{value : (effectiveEndDate < todayDate ? effectiveEndDate : effectiveEndDate + ' ' + String.fromCharCode(10142)+ ' ' + todayDate)}]}
                }
                
            })
            let todaysDate = moment.utc(new Date()).format("YYYY-MM-DD")
            updatedValue = {...updatedValue,  EffectiveEndDate:[{value: todaysDate}], ActiveFlag: [{value : 'N'}], IsStatusChanged: true}
            setValue({...value, ActiveFlag: [{value : 'N'}], AffiliationClassification: affiliationUpdated })
            props.editValue(updatedValue, false)
        }
        else{
            undoEditRealtion()
            setValue(props.value)
        }
       
    }
    
    const undoEditRealtion = () => {     
        let updatedValue = JSON.parse(JSON.stringify(props.value))
        setValue(props.value)
        updatedValue = {...updatedValue, IsStatusChanged: false}
        props.editValue(updatedValue, false)
    };
    
    /**
     * Handle Accordian click
     * @param {*} prev 
     */
    const closeAccordian = (prev) => {
        setAccordian(!prev)
    }

    /**
     * Handle Add operation
     * @param {*} attribute 
     */
    const addNewNested = (attribute) => {
        let length = 'XADcZS' + attribute + addnewIdArray.length;
        addnewIdArray.push(length);
        if (attribute === 'Speciality') {
            addNewAttribute({
                PrimarySpecialty: [{ value: '' }],
                OtherSpecialty: [{ value: '' }]
            }, false);
        }else if (attribute === 'Identifiers') {
            addNewAttribute({
                Type: [{ value: '' }],
                SubType: [{ value: '' }],
                Id: [{ value: '' }]
            }, false);
        }else if (attribute === 'Phone') {
            addNewAttribute({
                Number: [{ value: '' }]
            }, false);
        } else if (attribute === 'Email') {
            addNewAttribute({
                Email: [{ value: '' }]
            }, false);
        }
        else {
            const isLillyManagedHCO = props.entity === 'HCO' && CONSTANT.BRICK_LILLY_MANAGED_SOURCES.includes(props.source?.[0]?.value)
            addNewAttribute({
                AddressLine1: [{ value: '' }],
                City: [{ value: '' }],
                StateProvience: [{ value: '' }],
                Zip: [{ value: '' }],
                Rank: [{ value: '' }],
                EffectiveStartDate: [{ value: moment.utc(new Date()).format("YYYY-MM-DD") }],
                EffectiveEndDate: [{ value: "9999-12-31" }],
                ...(isLillyManagedHCO && {
                    BRICK: [{
                        [CONSTANT.BRICK_FIELDS.BRICK_TYPE]: [{ value: 'BRK' }],
                        [CONSTANT.BRICK_FIELDS.BRICK_ID]: [{ value: '' }],
                        [CONSTANT.BRICK_FIELDS.BRICK_EFFECTIVE_START_DATE]: [{ value: moment.utc(new Date()).format("YYYY-MM-DD") }],
                        [CONSTANT.BRICK_FIELDS.BRICK_EFFECTIVE_END_DATE]: [{ value: "9999-12-31" }],
                        [CONSTANT.BRICK_FIELDS.BRICK_SOURCE]: [{ value: props.source?.[0]?.value || '' }],
                    }],
                }),
            }, true);
        }

    }

    /**
     * Handel Delete Icon
     * @param {*} id 
     */
    const deleteNewItem = (id) => {
        props.updateValue(undefined, false)
        setAddNewIdArray(addnewIdArray.filter(res => res !== id))
    }

    /**
     * Pass value to parent
     * @param {*} newValue 
     * @param {*} flag 
     */
    const addNewAttribute = (newValue, flag) => {
        props.updateValue(newValue, flag)

    }

    /**
     * Show more
     */
    const showMore = () => {
        setIndexView(indexView + CONSTANT.SHOW_VALUE_INCREMENT);
        if (indexView + CONSTANT.SHOW_VALUE_INCREMENT < allValue.length) {
            setValue(allValue.slice(0, indexView + CONSTANT.SHOW_VALUE_INCREMENT))
        } else {
            setValue(allValue)
        }
    }

    // disable hcp deactivation for opendata HCO
    const hcpDeactivationDisable = (source, entityType, relationEntity)=>{
        if(SourceList.OPEN_DATA_SOURCES.includes(source) && entityType === 'HCO'){
            let relationEntityType = relationEntity?.startObject?.type !== undefined ? relationEntity?.startObject?.type.split('/')[2] : undefined;
            if(relationEntityType === "HCP"){
                return false;
            }
        }
        return true;
    }

    const EditRealtion = (index)=>{
        setAccordian(oldval => !oldval ? true : oldval )
        setEditMode(!editMode)
        props.editMode(!editMode, index)
        if(editMode == true){
            undoEditRealtion()
            setValue(props.value)
        }
    }

    /**
     * Show Less
     */
    const showLess = () => {
        setIndexView(CONSTANT.SHOW_VALUE_NUMBER);
        setValue(allValue.slice(0, CONSTANT.SHOW_VALUE_NUMBER))
    }

    /**
     * Handle Phone operation
     * @param {*} id 
     */
    const handelPhone = (id) => {
        if (id === 0) {
            setOpenPhone(!openPhone)
        } else if (id === 1) {
            setOpenRole(!openRole)
        } else if (id === 2) {
            setOpenAffilation(!openAffilation)
        } else {
            setOpenEmail(!openEmail)
        }
    }

    /**
     * filter the nested attribute
     * @param {*} search 
     */
    const filterData = (search) => {
        if (search.length > 0) {
            let attributes = props.heading.split('&');
            let unfilteredData = JSON.parse(JSON.stringify(props.value));
            let filteredValue = unfilteredData.filter((value) => {
                let containValue = false;
                let multipleValueFlag = '';
                attributes.forEach((attValue, i) => {

                    if (value[attValue] !== undefined && value[attValue].length > 0 && !CONSTANT.NOT_AN_ARRAY.includes(label)) {

                        value[attValue].forEach((res) => {
                            if (res.value !== undefined) {
                                multipleValueFlag += res.value.toLowerCase();
                            }
                        })

                        multipleValueFlag = (i === (attributes.length - 1)) ? multipleValueFlag : multipleValueFlag + ' ';
                    } else {
                        if (CONSTANT.NOT_AN_ARRAY.includes(label)) {
                            multipleValueFlag += value[attValue].split('/')[2].toLowerCase();
                        }
                    }
                })
                containValue = multipleValueFlag.includes(search.toLowerCase());
                return containValue;
            })
            let allSortedFormat = sortData(filteredValue, label)
            setAllValue(allSortedFormat.allValueSorted);
            setValue(allSortedFormat.firstTopValues)
        } else {
            let allSortedFormat = sortData(props.value, label)
            setAllValue(allSortedFormat.allValueSorted);
            setValue(allSortedFormat.firstTopValues)
        }
    }
    return (

        <Accordion className="shadow-none mt-2 col-12" expanded={accordian}>
            <AccordionSummary onClick={() => closeAccordian(accordian)}
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="FirstName"
                className='bg-grey'
            >
                {
                    label !== 'Relation' && label !== 'Address' &&
                    <Typography variant='subtitle1' className='fw-bold _wg-dynamic-text'>
                        {
                            label + relationName
                        }

                    </Typography>
                }
                {
                    label == 'Address' && props.mode === 'Edit' && props.entity == 'HCO' &&  
                    <Typography variant='subtitle1' className='fw-bold _wg-dynamic-text' sx={{display: 'flex', alignItems: 'center'}}>         
                        <span>{label}</span>                   
                        <Tooltip disableFocusListener
                            title='Only one address can be added or edited in a single DCR.'
                            id='tooltip'
                        >                           
                            <InfoOutlinedIcon className='ms-1 mt-1' style={{ fontSize: 16 }} />
                        </Tooltip>
                    </Typography> 
                }
                {
                   label == 'Address' && props.mode == 'Edit' && props.entity == 'HCP' &&
                   <Typography variant='subtitle1' className='fw-bold _wg-dynamic-text'>
                    {label}
                    </Typography>
                }
                {
                   label == 'Address' && (props.mode != 'Edit') &&
                   <Typography variant='subtitle1' className='fw-bold _wg-dynamic-text'>
                    {label}
                    </Typography>
                }                   
                
                {label === 'Relation' &&
                    <Link
                        to={'/details/' + urlRelation + '/' + typeUrl}
                        target="_blank"
                        rel="noopener noreferrer" className=" pl-3 mb-0">
                        {relationName}
                    </Link>
                }

                {label == 'Relation' && props.mode === 'Edit' && sourceConfig.ALLOWED_SOURCE_FOR_DEACTIVATION.includes(props.source[0].value) && !props.disableIcon && hcpDeactivationDisable(props.source[0].value, props.entity, value) &&
                    <Stack direction="row" spacing={1} sx={{ alignItems: 'center' , marginLeft: 'auto' , display: 'flex', marginRight: '5px' }}>
                        <IconButton
                        aria-label="more"
                        id="long-button"                            
                        aria-haspopup="true"
                        onClick={handleClickMenu}                            
                        >
                        {editMode ? <EditOffIcon color='primary' /> :<Edit color='primary' /> }
                        </IconButton>
                    
                    </Stack>
                    }   
            </AccordionSummary>
            <AccordionDetails className='border row container ms-1'>  
                    {props.specialtyDataSaved &&  props.label == 'Specialities' &&
                        <Alert severity="success" className='mb-2'>Specialities saved successfully </Alert>
                    }                             

                    {

                    label !== 'Relation' && props.mode !== 'Edit' && !props.noSearch
                        && allValue !== undefined && props.noSearch === undefined &&
                        < NestedSearch search={(key) => { filterData(key) }} label={label} />
                    }
                    {
                        props.mode === 'Edit' && (props.source && sourceConfig.ALLOWED_SOURCE_FOR_DEACTIVATION.includes(props.source[0].value) ? !props.addmoreAddressFlag &&  addnewIdArray.length === 0  : addnewIdArray.length === 0 && editFlag ) && ((props.addFlag && label !== 'Address') || (!props.addFlag && label === 'Address')) && (props.label != 'Specialities') &&
                        <Link to="#" onClick={() => addNewNested(label)} className="_wg-dynamic-text"><Add />ADD</Link>
                    }
                    {
                        props.mode === 'Edit' && (props.source && sourceConfig.EDITABLE_SOURCES.includes(props.source[0]?.value)  ? !props.addmoreAddressFlag &&  addnewIdArray.length === 0  : addnewIdArray.length === 0 && editFlag ) && (props.addFlag && label !== 'Address') &&  !sourceConfig.OPEN_DATA_SOURCES.includes(props.source[0].value) &&
                        <Link to="#" onClick={() =>addNewNested(label)} className="_wg-dynamic-text" ><Add />ADD</Link>
                    }
                    {
                        props.mode === 'Edit' && (props.source && sourceConfig.OPEN_DATA_SOURCES.includes(props.source[0].value)) && (props.label == 'Specialities') && sourceConfig.OPEN_DATA_SOURCES.includes(props.source[0].value) &&
                        <Stack direction='row' alignItems='center'>
                            <IconButton size='small' onClick={()=> props.openSpecialtyModal(false)}>
                                <Add />
                            </IconButton>
                            <Typography marginLeft='10px' className='_wg-dynamic-text' variant='subtitle1'>Add / Edit Specialties</Typography>
                        </Stack>
                        
                    }
                   

                    {
                        addnewIdArray.length > 0 && props.mode !== 'Viewing' &&
                        addnewIdArray.map((id, i) => {
                            return <ListViewInput
                            // prop drilling to handle rdm of vn hcp (iqvia_us)
                                vendor={props.vendor}
                                error={error} key={i} 
                                id={id}
                                change={changedFlag}
                                className="_wg-dynamic-text"
                                value={newValue} label='New'
                                deleteNewItem={(id) => deleteNewItem(id)}
                                mode={props.mode}
                                addNewAttribute={(nestedValue, flag) => addNewAttribute(nestedValue, flag)}
                                newValue={props.newValue}
                                source = {props.source ? props.source[0]?.value: null}
                                entity = { label != 'Address' ? props.entity : 'HCO'}
                                country={props.country}
                            />
                        })
                    }
    
                    {
                        label === 'Relation' && value !== undefined &&
                        < React.Fragment >
                            {
                                value && value?.startObject?.objectURI?.split('/')[1] !== props.id &&
                                <>
                                    <div className='row _wg-dynamic-text'>
                                        <div className='col-6'>
                                            <small>
                                                <span className="_wg-dynamic-text-muted mb-2  mt-2" ><strong>{'Relation Name :'}</strong></span>
                                                <span className=" pl-3 mb-0"> {value?.startObject?.label}</span>
                                            </small>
                                        </div>
                                        <div className='col-6'>
                                            <small>
                                                <span className="_wg-dynamic-text text-muted mb-2  mt-2">{'Type :'}</span>
                                                <span className="pl-3 mb-0"> {(value?.startObject?.type !== undefined) ? value?.startObject?.type.split('/')[2] : ''}</span>
                                            </small>
                                        </div>

                                    </div>
                                </>
                            }
                            {
                                value && value?.endObject?.objectURI?.split('/')[1] !== props.id &&
                                <>
                                    <div className='row _wg-dynamic-text'>
                                        <div className='col-6'>
                                            <small>
                                                <span className="text-muted mb-2  mt-2">{'Relation Name :'}</span>
                                                <span className=" pl-3 mb-0"> {value?.endObject?.label}</span>
                                            </small>
                                        </div>
                                        <div className='col-6'>
                                            <small>
                                                <span className="text text-muted mb-2  mt-2">{'Type :'}</span>
                                                <span className=" pl-3 mb-0"> {(value.endObject.type !== undefined) ? value.endObject.type.split('/')[2] : ''}</span>
                                            </small>
                                        </div>

                                    </div>
                                </>
                            }
                            {
                                value.Rank && <SingleValue label={'Rank'} value={value.Rank} />
                            }
                            {
                                value.ActiveFlag && <SingleValue  updatedValue = {(value, flag)=> updateRelation(value, flag)} mode={editMode ?'Edit' : undefined} label={'Active Flag'} value={value.ActiveFlag} country={props.country} entity={props.entity} />
                            }

                            {
                                value.Role
                                &&
                                <>
                                    {
                                        <List
                                            component="nav"
                                            aria-labelledby="nested-list-subheader"
                                        >
                                            <ListItem onClick={() => handelPhone(1)} className={openRole ? ' bg-muted' : ''}>
                                                {openRole ? <ExpandLess /> : <ArrowForwardIosIcon style={{ fontSize: 15 }} />}
                                                <ListItemText primary="Role" className='className="_wg-dynamic-text'/>

                                            </ListItem>
                                            <Collapse in={openRole} className='container mt-2' timeout="auto" unmountOnExit>
                                                {
                                                    value.Role.map((phoneValue, i) => {
                                                        return (<ListView key={i} label={((phoneValue.Hierarchy && phoneValue.Hierarchy.length > 0) ? phoneValue.Hierarchy[0].value : '') + ' - ' + ((phoneValue.RoleTypeCode && phoneValue.RoleTypeCode.length > 0) ? phoneValue.RoleTypeCode[0].value : '')} value={phoneValue} />)
                                                    })
                                                }
                                            </Collapse>
                                        </List>
                                    }
                                </>
                            }

                            {
                                value.AffiliationClassification &&
                                <>
                                    {
                                        <List
                                            component="nav"
                                            aria-labelledby="nested-list-subheader"
                                        >

                                            <ListItem onClick={() => handelPhone(2)} className={openAffilation ? ' bg-muted' : ''}>
                                                {openAffilation ? <ExpandLess /> : <ArrowForwardIosIcon style={{ fontSize: 15 }} />}
                                                <ListItemText primary="Affiliation Classification" className='className="_wg-dynamic-text' />


                                            </ListItem>
                                            <Collapse in={openAffilation} className='container mt-2' timeout="auto" unmountOnExit>
                                                {
                                                    value.AffiliationClassification.map((phoneValue, i) => {
                                                        return (<ListView id='relation' key={i} label={((phoneValue.Hierarchy && phoneValue.Hierarchy.length > 0) ? phoneValue.Hierarchy[0].value : '') + ' - ' + ((phoneValue.RelationshipTypeCode && phoneValue.RelationshipTypeCode.length > 0) ? phoneValue.RelationshipTypeCode[0].value : '')} value={phoneValue} />)
                                                    })
                                                }
                                            </Collapse>
                                        </List>
                                    }
                                </>
                            }


                        </React.Fragment>
                    }
                    
                    {
                    
                        value !== undefined && label === 'Specialities' && value?.map((element, i) => {
                            let heading = props.heading ? element[props?.heading] : Object.keys(element)[0];
                            return <ListView
                                    updateValue={(newValue, flag) => updateValue(newValue, i, flag)}
                                    key={i}
                                    label={((heading !== undefined && heading.length === 0) || heading === undefined) ? '<No Label>' : heading[0].value}
                                    value={element}
                                    fieldName = {props.label}
                                    entity = {props.entity}
                                    editSpecialty = {props.mode} 
                                    deleteSepcialty = {() => deleteSepcialty(i)}   
                                    undoDeleteSepcialty = {() => undoDeleteSepcialty(i)}
                                    source = {props.source ? props.source[0].value : null}
                                    freezEdit ={props.freezEdit}  />
                        })
                    }

                    {
                        label !== 'Relation' && value !== undefined && label !== 'Specialities'  &&
                        value?.map((element, i) => {                         
                            if (label === 'Sources') {
                                let sourceValue = {
                                    ...element,
                                    type: element.type ? element.type.split('/')[2] : ''
                                }
                                let newLabel = sourceValue[props.heading];                                
                                return <ListView key={i} label={newLabel} value={sourceValue} sources={true} />
                            }
                            else if(props.subhead === 'consents'){                              
                               
                                let fieldslabel  = GCCCp?.GCCP_UI_config[label?.replace(/\s/g, "")];                                
                                let sourceValue = { 
                                    ...element                                    
                                }           
                                let newLabel = sourceValue[props.heading];                               
                                if(label == 'Channel Consents')
                                {                          
                                    return(<React.Fragment key={i}>
                                    {                                        
                                        Object.values(sourceValue)?.map((res, index)=>{                                                                               
                                        return(
                                                <ConsentAccordian response ={res} subAccordianLabel = {res[0].ConsentType ? res[0]?.ConsentType : res[1]?.ConsentType } key = {index} label={newLabel || '<No Label>'} sources={false} fieldLabelData = {fieldslabel} listLabel={label} />
                                            )
                                        })
                                        
                                    }  
                                    </React.Fragment>)                            
                                }
                                else{
                                     return <ListView key={i} label={newLabel || '<No Label>'} value={sourceValue} sources={false} fieldLabelData = {fieldslabel} accordianLabel={label}/>
                                
                                }                                                          
                            }
                            
                            let partHeadingArray = props.heading.split('&');
                            if (partHeadingArray.length > 1) {
                                let newLabel = '';
                                let visitedFirst = true;
                                partHeadingArray.forEach((labelElement, i) => {
                                    let arrayValue = element[labelElement];
                                    if (arrayValue !== undefined && arrayValue.length > 0 && arrayValue[0].value !== undefined) {
                                        newLabel += (visitedFirst ? arrayValue[0].value : ' ' + arrayValue[0].value);
                                        visitedFirst = false;
                                    } else {
                                        newLabel = '<No Label >';
                                    }

                                });
                                return (props.heading &&
                                    <ListView
                                        mode={(label === 'Address' && !props.addFlag ) ? props.mode : ''}
                                        key={i}
                                        change={changedFlag}
                                        error={error}
                                        label={newLabel}
                                        value={element}
                                        editFlagTrue={(value) => { setEditFlag(value) }}
                                        deletePreviousChange={() => deletePreviousChange(i)}
                                        EditChange={() => { EditChange(i) }}
                                        updateValue={(newValue, flag, Name) => updateValue(newValue, i, flag, Name)}
                                        source = {props.source ? props.source[0].value : null}
                                        editMode = {(editFlag) => disableEditIcon(editFlag, i)}
                                        disableIcon = {(addressEditIndex[i] != true && props.addmoreAddressFlag) ? false : true}
                                        disableEditIcons = {addressEditIndexForVendor != i && addressEditFlag  ||  addnewIdArray.length > 0 ? false : true }
                                        //disableEditIcon = {props.mode == 'Edit' ? false : props.addmoreAddressFlag}
                                        entity = {props.entity}
                                        showBrick = {props.showBrick}
                                    />)
                            }
                            let heading = props.heading ? element[props?.heading] : Object.keys(element)[0];
                            return ((props.heading) &&
                                <ListView
                                    updateValue={(newValue, flag) => updateValue(newValue, i, flag)}
                                    key={i}
                                    label={((heading !== undefined && heading.length === 0) || heading === undefined) ? '<No Label>' : heading[0].value}
                                    value={element}
                                    fieldName = {props.label}
                                    entity = {props.entity}
                                    editSpecialty = {props.mode} 
                                    deleteSepcialty = {() => deleteSepcialty(i)}   
                                    undoDeleteSepcialty = {() => undoDeleteSepcialty(i)}
                                    source = {props.source ? props.source[0].value : null}
                                    freezEdit ={props.freezEdit}  />
                            )
                        })
                    }
                    {
                        allValue !== undefined && allValue.length === 0 &&
                        <div className='pt-2'>
                            <em className="_wg-dynamic-text">No data found</em>
                        </div>
                    }
                    {
                        allValue !== undefined && allValue.length > CONSTANT.SHOW_VALUE_NUMBER && allValue.length !== value.length &&
                        <Link to='#' className='d-flex justify-content-center _wg-dynamic-text' onClick={showMore}> ShowMore <Add /> </Link>
                    }
                    {
                        allValue !== undefined && allValue.length === value.length && value.length > CONSTANT.SHOW_VALUE_NUMBER &&
                        <Link to='#' className='d-flex justify-content-center _wg-dynamic-text' onClick={showLess}> ShowLess<Remove /></Link>
                    }
                    {
                        allValue === undefined &&
                        <div className='pt-2'>
                            <em className="_wg-dynamic-text">No data found</em>
                        </div>
                    }

                
            </AccordionDetails>
        </Accordion >


    );

}

export default MultiValue;